import type { PropsWithChildren } from "react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { TooltipProvider } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type ToolbarButtonProps = PropsWithChildren<{
  onClick: () => void;
  tooltip:
    | string
    | React.ReactNode
    | { title: string; description: string }
    | { description: string };
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  disabled?: boolean;
  disabledTooltip?:
    | string
    | React.ReactNode
    | { title: string; description: string };
}>;

export const ToolbarButton = ({
  onClick,
  children,
  tooltip,
  className,
  disabled = false,
  disabledTooltip,
}: ToolbarButtonProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={disabled ? "inline-block" : undefined}>
            <Button
              variant="ghost"
              onClick={onClick}
              size="sm"
              className={className}
              tabIndex={-1}
              disabled={disabled}
            >
              {children}
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent
          className={cn(
            "whitespace-pre-wrap max-w-[330px]",
            (disabled ||
              (typeof tooltip === "object" &&
                tooltip !== null &&
                ("title" in tooltip || "description" in tooltip))) &&
              "bg-background text-primary shadow",
          )}
        >
          {disabled ? (
            typeof disabledTooltip === "object" &&
            disabledTooltip !== null &&
            "title" in disabledTooltip &&
            "description" in disabledTooltip ? (
              <div className="flex flex-col gap-1">
                <span className="font-bold">{disabledTooltip.title}</span>
                <span className="font-normal">
                  {disabledTooltip.description}
                </span>
              </div>
            ) : (
              disabledTooltip
            )
          ) : typeof tooltip === "object" &&
            tooltip !== null &&
            "title" in tooltip &&
            "description" in tooltip ? (
            <div className="flex flex-col gap-1">
              <span className="font-bold">{tooltip.title}</span>
              <span className="font-normal">{tooltip.description}</span>
            </div>
          ) : typeof tooltip === "object" &&
            tooltip !== null &&
            "description" in tooltip ? (
            <span className="font-normal">{tooltip.description}</span>
          ) : (
            tooltip
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
